export class SearchDurationConst {
    public static Today: number = 1;
    public static LastThreeDays: number = 3;
    public static LastWeek: number = 7;
    public static LastTwoWeeks: number = 14;
    public static AnytimeOrAll = 0;
}